<template>
  <div id="app-matricula-online">
    <div class="app-container">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppMatriculaOnline'
};
</script>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Nunito+Sans&display=swap');

  #app-matricula-online {
    font-family: 'Nunito Sans' !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    max-width: 75%;
    min-width: auto;
    margin: 0 auto;
  }

  #card-prime {
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    font-family: 'Nunito Sans' !important;
  }
  
  .card, .p-card, .p-button-label, .p-dropdown-label {
    font-family: 'Nunito Sans' !important;
  }

  .message, .p-message {
    font-family: 'Nunito Sans' !important;
  }

  @media only screen and (max-width: 900px) {
    #app-matricula-online {
        max-width: 100%;
    }
  }

</style>